/**
 * Тона меток — фон и текст. Одна палитра на ERP: чипы, бейджи и цветные
 * кромки берут цвет отсюда, а не заводят свои hex рядом.
 *
 * Живёт в `components/constants`, а не в `pages/_detailShared/detail.styled`
 * (ТЗ 0096): значки коммуникаций рисует и шапка меню (organism), а
 * organism/molecule не импортирует страницы. `detail.styled` реэкспортирует
 * всё отсюда — прежние импорты работают.
 */
export type TagTone = 'ok' | 'warn' | 'danger' | 'neutral' | 'info' | 'gold';

export const TAG_TONE_COLORS: Readonly<
  Record<TagTone, { bg: string; fg: string }>
> = {
  ok: { bg: 'var(--k-bg-dcfce7)', fg: 'var(--k-fg-166534)' },
  warn: { bg: 'var(--k-bg-ffedd5)', fg: 'var(--k-fg-9a3412)' },
  danger: { bg: 'var(--k-bg-fee2e2)', fg: 'var(--k-fg-991b1b)' },
  info: { bg: 'var(--k-bg-dbeafe)', fg: 'var(--k-fg-1e40af)' },
  gold: { bg: 'var(--k-bg-fef9c3)', fg: 'var(--k-fg-854d0e)' },
  neutral: { bg: 'var(--k-bg-f1f5f9)', fg: 'var(--k-fg-475569)' },
};

/** Цвета тона; незнакомый тон — нейтральный (как было у `Tag`). */
export const tagToneColors = (tone?: TagTone | null) =>
  (tone && TAG_TONE_COLORS[tone]) || TAG_TONE_COLORS.neutral;
